import { TRIGGER_SEND_MONEY_BANK_LIST_API_SUCCESS } from 'redux/actionTypes';

const initialState = [];

// export const locale[];

const SendMoneyBankListReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_SEND_MONEY_BANK_LIST_API_SUCCESS:
			return action.data;
		default:
			return state;
	}
};

export default SendMoneyBankListReducer;
